export const GET_QA_TEMPLATES = 'GET_QA_TEMPLATES';
export const QA_TEMPLATES_ERROR = 'QA_TEMPLATES_ERROR';

export const GET_PO_DETAILS = 'GET_PO_DETAILS';
export const PO_DETAILS_ERROR = 'PO_DETAILS_ERROR';

export const GET_DEPARTMENT_SEARCH = 'GET_DEPARTMENT_SEARCH';
export const DEPARTMENT_SEARCH_ERROR = 'DEPARTMENT_SEARCH_ERROR';

export const GET_PO_SEARCH = 'GET_PO_SEARCH';
export const PO_SEARCH_ERROR = 'PO_SEARCH_ERROR';

export const POST_PO_LINEITEMS = 'POST_PO_LINEITEMS';
export const POST_PO_LINEITEMS_ERROR = 'POST_PO_LINEITEMS_ERROR';

export const INSPECTION_DASHBOARD = 'INSPECTION_DASHBOARD';
export const INSPECTION_DASHBOARD_ERROR = 'INSPECTION_DASHBOARD_ERROR';

export const GET_STAGES_BY_POLINEITEMID = 'GET_STAGES_BY_POLINEITEMID';
export const GET_STAGES_BY_POLINEITEMID_ERROR = 'GET_STAGES_BY_POLINEITEMID_ERROR';

export const GET_VENDOR_PO_DETAILS = 'GET_VENDOR_PO_DETAILS';
export const GET_VENDOR_PO_DETAILS_ERROR = 'GET_VENDOR_PO_DETAILS_ERROR';

export const POST_REQUEST_INSPECTION = 'POST_REQUEST_INSPECTION';
export const POST_REQUEST_INSPECTION_ERROR = 'POST_REQUEST_INSPECTION_ERROR';

export const POST_ASSIGN_INSPECTOR = 'POST_ASSIGN_INSPECTOR';
export const POST_ASSIGN_INSPECTOR_ERROR = 'POST_ASSIGN_INSPECTOR_ERROR';

export const POST_WAIVEOFF_INSPECTION = 'POST_WAIVEOFF_INSPECTION';
export const POST_WAIVEOFF_INSPECTION_ERROR = 'POST_WAIVEOFF_INSPECTION_ERROR';

export const POST_ACCEPT_REJECT_INSPECTION = 'POST_ACCEPT_REJECT_INSPECTION';
export const POST_ACCEPT_REJECT_INSPECTION_ERROR = 'POST_ACCEPT_REJECT_INSPECTION_ERROR';

export const GET_INSPECTION_DETAILS_BY_INSPECTORID = 'GET_INSPECTION_DETAILS_BY_INSPECTORID';
export const GET_INSPECTION_DETAILS_BY_INSPECTORID_ERROR = 'GET_INSPECTION_DETAILS_BY_INSPECTORID_ERROR';

export const GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD = 'GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD';
export const GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD_ERROR = 'GET_INSPECTION_DETAILS_BY_INSPECTORID_FOR_DASHBOARD_ERROR';

export const INSPECTION_DASHBOARD_DOCUMENT = 'INSPECTION_DASHBOARD_DOCUMENT';
export const INSPECTION_DASHBOARD_DOCUMENT_ERROR = 'INSPECTION_DASHBOARD_DOCUMENT_ERROR';

export const GET_SUPPLIER_POS = 'GET_SUPPLIER_POS';
export const GET_SUPPLIER_POS_ERROR = 'GET_SUPPLIER_POS_ERROR';

export const GET_ALL_INSPECTORS_WITH_TYPE = 'GET_ALL_INSPECTORS_WITH_TYPE';
export const GET_ALL_INSPECTORS_WITH_TYPE_ERROR = 'GET_ALL_INSPECTORS_WITH_TYPE_ERROR';

export const GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID = 'GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID';
export const GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID_ERROR = 'GET_INSPECTOR_ALLOCATIONS_BY_INSPECTOR_ID_ERROR';

export const GET_INSPECTOR_ALLOCATIONS = 'GET_INSPECTOR_ALLOCATIONS';
export const GET_INSPECTOR_ALLOCATIONS_ERROR = 'GET_INSPECTOR_ALLOCATIONS_ERROR';

export const POST_CLAIM_PO = 'POST_CLAIM_PO';
export const POST_CLAIM_PO_ERROR = 'POST_CLAIM_PO_ERROR';

export const GET_INSPECTION_DETAILS_BY_CALLID = 'GET_INSPECTION_DETAILS_BY_CALLID';
export const GET_INSPECTION_DETAILS_BY_CALLID_ERROR = 'GET_INSPECTION_DETAILS_BY_CALLID_ERROR';

export const GET_INSPECTION_STATUS_MASTER = 'GET_INSPECTION_STATUS_MASTER';
export const GET_INSPECTION_STATUS_MASTER_ERROR = 'GET_INSPECTION_STATUS_MASTER_ERROR';

export const FILE_UPLOAD = 'FILE_UPLOAD';
export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR';

export const POST_SAVE_LINE_ITEM_PO = 'POST_SAVE_LINE_ITEM_PO';
export const POST_SAVE_LINE_ITEM_PO_ERROR = 'POST_SAVE_LINE_ITEM_PO_ERROR';

export const POST_SAVE_LINE_ITEM_PO_STAGE = 'POST_SAVE_LINE_ITEM_PO_STAGE';
export const POST_SAVE_LINE_ITEM_PO_STAGE_ERROR = 'POST_SAVE_LINE_ITEM_PO_STAGE_ERROR';

export const PO_PURCHACE_ORDER_LIST = 'PO_PURCHACE_ORDER_LIST';
export const PO_PURCHACE_ORDER_LIST_ERROR = 'PO_PURCHACE_ORDER_LIST_ERROR';

export const REQUEST_PO_PURCHACE_ACTION = 'REQUEST_PO_PURCHACE_ACTION';
export const REQUEST_PO_PURCHACE_ACTION_ERROR = 'REQUEST_PO_PURCHACE_ACTION_ERROR';

export const PO_PURCHACE_ORDER_LIST_FOR_VENDOR = 'PO_PURCHACE_ORDER_LIST_FOR_VENDOR';
export const PO_PURCHACE_ORDER_LIST_FOR_VENDOR_ERROR = 'PO_PURCHACE_ORDER_LIST_FOR_VENDOR_ERROR';

export const PATCH_UPDATE_INSPECTION_STATUS = 'PATCH_UPDATE_INSPECTION_STATUS';
export const PATCH_UPDATE_INSPECTION_STATUS_ERROR = 'PATCH_UPDATE_INSPECTION_STATUS_ERROR';


export const POST_SEND_TO_VENDOR = 'POST_SEND_TO_VENDOR';
export const POST_SEND_TO_VENDOR_ERROR = 'POST_SEND_TO_VENDOR_ERROR';

export const CHANGE_DOC_STATUS_CHANGE = 'CHANGE_DOC_STATUS_CHANGE';
export const CHANGE_DOC_STATUS_CHANGE_ERROR = 'CHANGE_DOC_STATUS_CHANGE_ERROR';

export const FILE_VERSIONS = 'FILE_VERSIONS';
export const FILE_VERSIONS_ERROR = 'FILE_VERSIONS_ERROR';


export const GET_SUPPLIER_POS_WITH_STAGES = 'GET_SUPPLIER_POS_WITH_STAGES';
export const GET_SUPPLIER_POS_WITH_STAGES_ERROR = 'GET_SUPPLIER_POS_WITH_STAGES_ERROR';
export const SUPPLIER_INSPECTION = 'SUPPLIER_INSPECTION';
export const SUPPLIER_INSPECTION_ERROR = 'SUPPLIER_INSPECTION_ERROR';

export const POST_UNCLAIM_PO = 'POST_UNCLAIM_PO';
export const POST_UNCLAIM_PO_ERROR = 'POST_UNCLAIM_PO_ERROR';

export const DOCUMENT_COMMENTS = 'DOCUMENT_COMMENTS';
export const DOCUMENT_COMMENTS_ERROR = 'DOCUMENT_COMMENTS_ERROR';

export const PO_NEW_VERSION_FILE_UPLOAD = 'PO_NEW_VERSION_FILE_UPLOAD';
export const PO_NEW_VERSION_FILE_UPLOAD_ERROR = 'PO_NEW_VERSION_FILE_UPLOAD_ERROR';

export const POST_PO_SEARCH = 'POST_PO_SEARCH';
export const POST_PO_SEARCH_ERROR = 'POST_PO_SEARCH_ERROR';

export const GET_ALL_INVOICES = 'GET_ALL_INVOICES';
export const GET_ALL_INVOICES_ERROR = 'GET_ALL_INVOICES_ERROR';

export const GET_PO_SEARCH_BY_VENDOR = 'GET_PO_SEARCH_BY_VENDOR';
export const GET_PO_SEARCH_BY_VENDOR_ERROR = 'GET_PO_SEARCH_BY_VENDOR_ERROR';

export const GET_DUE_AMOUNTS = 'GET_DUE_AMOUNTS';
export const GET_DUE_AMOUNTS_ERROR = 'GET_DUE_AMOUNTS_ERROR';

export const GET_ALL_MASTER_DATA = 'GET_ALL_MASTER_DATA';
export const GET_ALL_MASTER_DATA_ERROR = 'GET_ALL_MASTER_DATA_ERROR';

export const SET_INVOICE_PAYMENT_MEDIUM = 'SET_INVOICE_PAYMENT_MEDIUM';
export const SET_INVOICE_PAYMENT_MEDIUM_ERROR = 'SET_INVOICE_PAYMENT_MEDIUM_ERROR';

export const FILE_UPLOAD_ADVANCED = 'FILE_UPLOAD_ADVANCED';
export const FILE_UPLOAD_ADVANCED_ERROR = 'FILE_UPLOAD_ADVANCED_ERROR';

export const POST_SEND_COMMENT = 'POST_SEND_COMMENT';
export const POST_SEND_COMMENT_ERROR = 'POST_SEND_COMMENT_ERROR';

export const POST_EDIT_STAGE = 'POST_EDIT_STAGE';
export const POST_EDIT_STAGE_ERROR = 'POST_EDIT_STAGE_ERROR';

export const GET_CALL_LINEITEM_DETAILS_BY_CALLID = 'GET_CALL_LINEITEM_DETAILS_BY_CALLID';
export const GET_CALL_LINEITEM_DETAILS_BY_CALLID_ERROR = 'GET_CALL_LINEITEM_DETAILS_BY_CALLID_ERROR';

export const PO_ACCEPTANCE_TO_PO = 'PO_ACCEPTANCE_TO_PO';
export const PO_ACCEPTANCE_TO_PO_ERROR = 'PO_ACCEPTANCE_TO_PO_ERROR';

export const CHANGE_SUPPLIER_DOCUMENT_STATUS = 'CHANGE_SUPPLIER_DOCUMENT_STATUS';
export const CHANGE_SUPPLIER_DOCUMENT_STATUS_ERROR = 'CHANGE_SUPPLIER_DOCUMENT_STATUS_ERROR';

export const GET_DOCUMENT_FOR_ADVANCE = 'GET_DOCUMENT_FOR_ADVANCE';
export const GET_DOCUMENT_FOR_ADVANCE_ERROR = 'GET_DOCUMENT_FOR_ADVANCE_ERROR';


export const POST_UPDATE_DOCUMENTID_FOR_ADAVANCE = 'GET_DOCUMENT_FOR_ADVANCE';
export const POST_UPDATE_DOCUMENTID_FOR_ADAVANCE_ERROR = 'GET_DOCUMENT_FOR_ADVANCE_ERROR';
export const UPDATE_STATUS_FORFINANCE = 'UPDATE_STATUS_FORFINANCE';
export const UPDATE_STATUS_FORFINANCE_ERROR = 'UPDATE_STATUS_FORFINANCE_ERROR';

export const INSERT_BUDGET_AMOUNT = 'INSERT_BUDGET_AMOUNT';
export const INSERT_BUDGET_AMOUNT_ERROR = 'INSERT_BUDGET_AMOUNT_ERROR';
export const POST_POACCEPTANCE_DOCUMENT_APPROVAL = 'GET_DOCUMENT_FOR_ADVANCE';
export const POST_POACCEPTANCE_DOCUMENT_APPROVAL_ERROR = 'GET_DOCUMENT_FOR_ADVANCE_ERROR';

export const GET_BUDGET_AMOUNT = 'GET_BUDGET_AMOUNT';
export const GET_BUDGET_AMOUNT_ERROR = 'GET_BUDGET_AMOUNT_ERROR';

export const UPDATE_PRIORITY = 'UPDATE_PRIORITY';
export const UPDATE_PRIORITY_ERROR = 'UPDATE_PRIORITY_ERROR';

export const POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS = 'POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS';
export const POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS_ERROR = 'POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS_ERROR';

export const GET_ALL_INVOICES_FOR_SPECIAL_CASE = 'GET_ALL_INVOICES_FOR_SPECIAL_CASE';
export const GET_ALL_INVOICES_FOR_SPECIAL_CASE_ERROR = 'GET_ALL_INVOICES_FOR_SPECIAL_CASE_ERROR';

export const GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED = 'GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED';
export const GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED_ERROR = 'GET_ALL_INVOICES_WHERE_PAYEMENT_RECEIVED_ERROR';

export const UPDATE_PAYABLE_AMOUNT_IN_INVOICE = 'UPDATE_PAYABLE_AMOUNT_IN_INVOICE';
export const UPDATE_PAYABLE_AMOUNT_IN_INVOICE_ERROR = 'UPDATE_PAYABLE_AMOUNT_IN_INVOICE_ERROR';

export const UPDATE_COMMENT_IN_INVOICE = 'UPDATE_COMMENT_IN_INVOICE';
export const UPDATE_COMMENT_IN_INVOICE_ERROR = 'UPDATE_COMMENT_IN_INVOICE_ERROR';

export const GET_ALL_SUPPLIERS = 'GET_ALL_SUPPLIERS';
export const GET_ALL_SUPPLIERS_ERROR = 'GET_ALL_SUPPLIERS_ERROR';

export const GET_ALL_PROJECT_NUMBER = 'GET_ALL_PROJECT_NUMBER';
export const GET_ALL_PROJECT_NUMBER_ERROR = 'GET_ALL_PROJECT_NUMBER_ERROR';

export const GET_ALL_ORDER_NUMBER = 'GET_ALL_ORDER_NUMBER';
export const GET_ALL_ORDER_NUMBER_ERROR = 'GET_ALL_ORDER_NUMBER_ERROR';

export const GET_ADVANCE_COMMENTS = 'GET_ADVANCE_COMMENTS';
export const GET_ADVANCE_COMMENTS_ERROR = 'GET_ADVANCE_COMMENTS_ERROR';

export const INSERT_ADVANCE_COMMENT = 'INSERT_ADVANCE_COMMENT';
export const INSERT_ADVANCE_COMMENT_ERROR = 'INSERT_ADVANCE_COMMENT_ERROR';

export const GET_ALL_DETAILS_FOR_DISPATCH = 'GET_ALL_DETAILS_FOR_DISPATCH';
export const GET_ALL_DETAILS_FOR_DISPATCH_ERROR = 'GET_ALL_DETAILS_FOR_DISPATCH_ERROR';

export const GET_ALL_PO_ITEM_DETAILS = 'GET_ALL_PO_ITEM_DETAILS';
export const GET_ALL_PO_ITEM_DETAILS_ERROR = 'GET_ALL_PO_ITEM_DETAILS_ERROR';

export const REQUEST_PO_DISPATCH_CLEARANCE = 'REQUEST_PO_DISPATCH_CLEARANCE';
export const REQUEST_PO_DISPATCH_CLEARANCE_ERROR = 'REQUEST_PO_DISPATCH_CLEARANCE_ERROR';

export const GET_ALL_PO_DETAILS = 'GET_ALL_PO_DETAILS';
export const GET_ALL_PO_DETAILS_ERROR = 'GET_ALL_PO_DETAILS_ERROR';

export const GET_ALL_SMS_DOCUMENTS = 'GET_ALL_SMS_DOCUMENTS';
export const GET_ALL_SMS_DOCUMENTS_ERROR = 'GET_ALL_SMS_DOCUMENTS_ERROR';

export const GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER = 'GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER';
export const GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_ERROR = 'GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_ERROR';

export const UPDATE_STATUS_FOR_DISPATCH = 'UPDATE_STATUS_FOR_DISPATCH';
export const UPDATE_STATUS_FOR_DISPATCH_ERROR = 'UPDATE_STATUS_FOR_DISPATCH_ERROR';


export const GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS = 'GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS';
export const GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS_ERROR = 'GET_ALL_DETAILS_FOR_DISPATCH_SUPPLIER_DOCUMENTS_ERROR';

export const GET_PO_DETAILS_FOR_DISPATCH_MATERIAL = 'GET_PO_DETAILS_FOR_DISPATCH_MATERIAL';
export const GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_ERROR = 'GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_ERROR';

export const UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS = 'UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS';
export const UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS_ERROR = 'UPDATE_DOCUMENTID_FOR_DISPATCH_DOCUMENTS_ERROR';

export const GET_PO_DETAILS_FOR_DISPATCH_PO_HEADER_MATERIAL = 'GET_PO_DETAILS_FOR_DISPATCH_PO_HEADER_MATERIAL';
export const GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_PO_HEADER_ERROR = 'GET_PO_DETAILS_FOR_DISPATCH_MATERIAL_PO_HEADER_ERROR';

export const UPDATE_DISPATCH_STATUS = 'UPDATE_DISPATCH_STATUS';
export const UPDATE_DISPATCH_STATUS_ERROR = 'UPDATE_DISPATCH_STATUS_ERROR';

export const GENERATE_DISPATCH_CLEARENCE = 'GENERATE_DISPATCH_CLEARENCE';
export const GENERATE_DISPATCH_CLEARENCE_ERROR = 'GENERATE_DISPATCH_CLEARENCE_ERROR';

export const GET_GRN_PO_HEADER = 'GET_GRN_PO_HEADER';
export const GET_GRN_PO_HEADER_ERROR = 'GET_GRN_PO_HEADER_ERROR';

export const GET_GRN_PO_LINE_ITEM = 'GET_GRN_PO_LINE_ITEM';
export const GET_GRN_PO_LINE_ITEM_ERROR = 'GET_GRN_PO_LINE_ITEM_ERROR';

export const GET_BLANK_DOCUMENTS_SEARCH = 'GET_BLANK_DOCUMENTS_SEARCH';
export const GET_BLANK_DOCUMENTS_SEARCH_ERROR = 'GET_BLANK_DOCUMENTS_SEARCH_ERROR';

export const GET_DOCUMENTS_UPLOADED_BY_INSPECTOR = 'GET_DOCUMENTS_UPLOADED_BY_INSPECTOR';
export const GET_DOCUMENTS_UPLOADED_BY_INSPECTOR_ERROR = 'GET_DOCUMENTS_UPLOADED_BY_INSPECTOR_ERROR';

export const POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT = 'POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT';
export const POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT_ERROR = 'POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT_ERROR';

export const POST_SPLIT_BUDGET = 'POST_SPLIT_BUDGET';
export const POST_SPLIT_BUDGET_ERROR = 'POST_SPLIT_BUDGET_ERROR';

export const GET_SPLIT_BUDGET = 'GET_SPLIT_BUDGET';
export const GET_SPLIT_BUDGET_ERROR = 'GET_SPLIT_BUDGET_ERROR';

export const GET_ALL_INVOICES_FOR_SUPLLIER = 'GET_ALL_INVOICES_FOR_SUPLLIER';
export const GET_ALL_INVOICES_FOR_SUPLLIER_ERROR = 'GET_ALL_INVOICES_FOR_SUPLLIER_ERROR';

export const GET_PAYMENT_TERM_DETAILS = 'GET_PAYMENT_TERM_DETAILS';
export const GET_PAYMENT_TERM_DETAILS_ERROR = 'GET_PAYMENT_TERM_DETAILS_ERROR';

export const GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER = 'GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER';
export const GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER_ERROR = 'GET_ALL_PO_ACCEPTANCE_DETAIL_FOR_SUPPLIER_ERROR';

export const GET_ALL_PO_UPLOADED_FOR_DS = 'GET_ALL_PO_UPLOADED_FOR_DS';
export const GET_ALL_PO_UPLOADED_FOR_DS_ERROR = 'GET_ALL_PO_UPLOADED_FOR_DS_ERROR';

export const POST_DETAILS_FOR_DELIVERY_SCHEDULE = 'POST_DETAILS_FOR_DELIVERY_SCHEDULE';
export const POST_DETAILS_FOR_DELIVERY_SCHEDULE_ERROR = 'POST_DETAILS_FOR_DELIVERY_SCHEDULE_ERROR';

export const UPDATE_DELIVERY_SCHEDULE_DETAILS = 'UPDATE_DELIVERY_SCHEDULE_DETAILS';
export const UPDATE_DELIVERY_SCHEDULE_DETAILS_ERROR = 'UPDATE_DELIVERY_SCHEDULE_DETAILS_ERROR';

export const GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER = 'GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER';
export const GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER_ERROR = 'GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER_ERROR';

export const POST_COMMENTS_FOR_POS = 'POST_COMMENTS_FOR_POS';
export const POST_COMMENTS_FOR_POS_ERROR = 'POST_COMMENTS_FOR_POS_ERROR';

export const GET_COMMENTS_FOR_POS = 'GET_COMMENTS_FOR_POS';
export const GET_COMMENTS_FOR_POS_ERROR = 'GET_COMMENTS_FOR_POS_ERROR';

export const GET_DOCUMENTS_FOR_EXPEDITING = 'GET_DOCUMENTS_FOR_EXPEDITING';
export const GET_DOCUMENTS_FOR_EXPEDITING_ERROR = 'GET_DOCUMENTS_FOR_EXPEDITING_ERROR';

export const GET_DOCUMENT_DETAILS_FOR_EXPEDITING = 'GET_DOCUMENT_DETAILS_FOR_EXPEDITING';
export const GET_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR = 'GET_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR';

export const POST_DOCUMENT_DETAILS_FOR_EXPEDITING = 'GET_DOCUMENT_DETAILS_FOR_EXPEDITING';
export const POST_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR = 'GET_DOCUMENT_DETAILS_FOR_EXPEDITING_ERROR';

export const UPDATE_APPROVAL_STATUS_FOR_EXPEDITING = 'UPDATE_APPROVAL_STATUS_FOR_EXPEDITING';
export const UPDATE_APPROVAL_STATUS_FOR_EXPEDITING_ERROR = 'UPDATE_APPROVAL_STATUS_FOR_EXPEDITING_ERROR';

export const GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING = 'GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING';
export const GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING_ERROR = 'GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING_ERROR';

export const GET_NEXT_ACTION_ROLE_FOR_APPROVAL = 'GET_NEXT_ACTION_ROLE_FOR_APPROVAL';
export const GET_NEXT_ACTION_ROLE_FOR_APPROVAL_ERROR = 'GET_NEXT_ACTION_ROLE_FOR_APPROVAL_ERROR';

export const GET_ENGINEERING_MASTER = 'GET_ENGINEERING_MASTER';
export const GET_ENGINEERING_MASTER_ERROR = 'GET_ENGINEERING_MASTER_ERROR';

export const GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM = 'GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM';
export const GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM_ERROR = 'GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM_ERROR';

export const GET_PAYMENT_TERM_DOCUMENTS = 'GET_PAYMENT_TERM_DOCUMENTS';
export const GET_PAYMENT_TERM_DOCUMENTS_ERROR = 'GET_PAYMENT_TERM_DOCUMENTS_ERROR';

export const GET_ALL_PO_LIST_BY_USERID = 'GET_ALL_PO_LIST_BY_USERID';
export const GET_ALL_PO_LIST_BY_USERID_ERROR = 'GET_ALL_PO_LIST_BY_USERID_ERROR';

export const GET_POLINEITEM_BY_POID = 'GET_POLINEITEM_BY_POID';
export const GET_POLINEITEM_BY_POID_ERROR = 'GET_POLINEITEM_BY_POID_ERROR';

export const GET_AUDIT_TRAILS_FOR_PO_AND_USER = "GET_AUDIT_TRAILS_FOR_PO_AND_USER";
export const GET_AUDIT_TRAILS_FOR_PO_AND_USER_ERROR = "GET_AUDIT_TRAILS_FOR_PO_AND_USER_ERROR";

export const INSERT_AUDIT_TRAIL = 'INSERT_AUDIT_TRAIL';
export const INSERT_AUDIT_TRAIL_ERROR = 'INSERT_AUDIT_TRAIL_ERROR';

export const GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID = 'GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID';
export const GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID_ERROR = 'GET_AUDIT_TRAIL_BY_PO_AND_LINE_ITEM_ID_ERROR';

export const UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE = 'UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE';
export const UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE_ERROR = 'UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE_ERROR';

export const POST_CLAIM_PO_FOR_EXPEDITOR = 'POST_CLAIM_PO_FOR_EXPEDITOR';
export const POST_CLAIM_PO_FOR_EXPEDITOR_ERROR = 'POST_CLAIM_PO_FOR_EXPEDITOR_ERROR';

export const POST_UNCLAIM_PO_FOR_EXPEDITOR = 'POST_UNCLAIM_PO_FOR_EXPEDITOR';
export const POST_UNCLAIM_PO_FOR_EXPEDITOR_ERROR = 'POST_UNCLAIM_PO_FOR_EXPEDITOR_ERROR';

export const GET_EXPEDITING_DOCUMENT_WITH_DETAILS = 'GET_EXPEDITING_DOCUMENT_WITH_DETAILS';
export const GET_EXPEDITING_DOCUMENT_WITH_DETAILS_ERROR = 'GET_EXPEDITING_DOCUMENT_WITH_DETAILS_ERROR';

export const UPDATE_STATUS_FOR_EXPEDITING = 'UPDATE_STATUS_FOR_EXPEDITING';
export const UPDATE_STATUS_FOR_EXPEDITING_ERROR = 'UPDATE_STATUS_FOR_EXPEDITING_ERROR';

export const GET_ASSIGNED_ENGINEER_DETAILS = 'GET_ASSIGNED_ENGINEER_DETAILS';
export const GET_ASSIGNED_ENGINEER_DETAILS_ERROR = 'GET_ASSIGNED_ENGINEER_DETAILS_ERROR';

export const UPDATE_ENGINEER_ASSIGNMENT_DETAILS = 'UPDATE_ENGINEER_ASSIGNMENT_DETAILS';
export const UPDATE_ENGINEER_ASSIGNMENT_DETAILS_ERROR = 'UPDATE_ENGINEER_ASSIGNMENT_DETAILS_ERROR';

export const GET_NEXT_ACTED_USERID = 'GET_NEXT_ACTED_USERID';
export const GET_NEXT_ACTED_USERID_ERROR = 'GET_NEXT_ACTED_USERID_ERROR';

export const GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE = 'GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE';
export const GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE_ERROR = 'GET_VENDOR_PO_DETAILS_FOR_PO_ACCEPTANCE_ERROR';

export const POST_INVOICE_DETAILS = 'POST_INVOICE_DETAILS';
export const POST_INVOICE_DETAILS_ERROR = 'POST_INVOICE_DETAILS_ERROR';

export const GET_ALL_CURRENCY_TYPES = 'GET_ALL_CURRENCY_TYPES';
export const GET_ALL_CURRENCY_TYPES_ERROR = 'GET_ALL_CURRENCY_TYPES_ERROR';

export const GET_DRAWINGS_FOR_EXPEDITING = 'GET_DRAWINGS_FOR_EXPEDITING';
export const GET_DRAWINGS_FOR_EXPEDITING_ERROR = 'GET_DRAWINGS_FOR_EXPEDITING_ERROR';

export const POST_DRAWING_DOCUMENT_DETAILS = 'POST_DRAWING_DOCUMENT_DETAILS';
export const POST_DRAWING_DOCUMENT_DETAILS_ERROR = 'POST_DRAWING_DOCUMENT_DETAILS_ERROR';

export const GET_DRAWING_ACTION_DETAILS = 'GET_DRAWING_ACTION_DETAILS';
export const GET_DRAWING_ACTION_DETAILS_ERROR = 'GET_DRAWING_ACTION_DETAILS_ERROR';

export const GET_ALL_ASSIGNED_ENGINEER_DETAILS = 'GET_ALL_ASSIGNED_ENGINEER_DETAILS';
export const GET_ALL_ASSIGNED_ENGINEER_DETAILS_ERROR = 'GET_ALL_ASSIGNED_ENGINEER_DETAILS_ERROR';

export const POST_ASSIGNED_ENGINEER_DETAILS = 'POST_ASSIGNED_ENGINEER_DETAILS';
export const POST_ASSIGNED_ENGINEER_DETAILS_ERROR = 'POST_ASSIGNED_ENGINEER_DETAILS_ERROR';

export const POST_MANUFACTURING_CLEARENCE_DETAILS = 'POST_MANUFACTURING_CLEARENCE_DETAILS';
export const POST_MANUFACTURING_CLEARENCE_DETAILS_ERROR = 'POST_MANUFACTURING_CLEARENCE_DETAILS_ERROR';

export const GET_MANUFACTURING_CLEARENCE_DETAILS = 'GET_MANUFACTURING_CLEARENCE_DETAILS';
export const GET_MANUFACTURING_CLEARENCE_DETAILS_ERROR = 'GET_MANUFACTURING_CLEARENCE_DETAILS_ERROR';

export const GET_DOCUMENT_COMMENTS_BY_DOCUMENTID = 'GET_DOCUMENT_COMMENTS_BY_DOCUMENTID';
export const GET_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR = 'GET_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR';

export const POST_DOCUMENT_COMMENTS_BY_DOCUMENTID = 'POST_DOCUMENT_COMMENTS_BY_DOCUMENTID';
export const POST_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR = 'POST_DOCUMENT_COMMENTS_BY_DOCUMENTID_ERROR';

export const GET_CLAIM_DETAILS_FOR_EXPEDITING = 'GET_CLAIM_DETAILS_FOR_EXPEDITING';
export const GET_CLAIM_DETAILS_FOR_EXPEDITING_ERROR = 'GET_CLAIM_DETAILS_FOR_EXPEDITING_ERROR';

export const GET_PO_AND_POLINEITEMS_SEARCH = 'GET_PO_AND_POLINEITEMS_SEARCH';
export const GET_PO_AND_POLINEITEMS_SEARCH_ERROR = 'GET_PO_AND_POLINEITEMS_SEARCH_ERROR';

export const REMOVE_LINE_ITEM_PO_STAGE = 'REMOVE_LINE_ITEM_PO_STAGE';
export const REMOVE_LINE_ITEM_PO_STAGE_ERROR = 'REMOVE_LINE_ITEM_PO_STAGE_ERROR';
export const GET_PAYMENT_TERM_DETAILS_BY_PO_ID = 'GET_PAYMENT_TERM_DETAILS_BY_PO_ID';
export const GET_PAYMENT_TERM_DETAILS_BY_PO_ID_ERROR = 'GET_PAYMENT_TERM_DETAILS_BY_PO_ID_ERROR';

export const POST_PO_TANSMITTLE_DOCUMENT_DETAILS = 'POST_PO_TANSMITTLE_DOCUMENT_DETAILS';
export const POST_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR = 'POST_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR';

export const GET_PO_TANSMITTLE_DOCUMENT_DETAILS = 'GET_PO_TANSMITTLE_DOCUMENT_DETAILS';
export const GET_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR = 'GET_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR';

export const UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS = 'UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS';
export const UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR = 'UPDATE_PO_TANSMITTLE_DOCUMENT_DETAILS_ERROR';

export const PARTIAL_APPROVAL_FOR_EXPEDITING = 'PARTIAL_APPROVAL_FOR_EXPEDITING';
export const PARTIAL_APPROVAL_FOR_EXPEDITING_ERROR = 'PARTIAL_APPROVAL_FOR_EXPEDITING_ERROR';

export const UPDATE_CLEARENCE_STATUS = 'UPDATE_CLEARENCE_STATUS';
export const UPDATE_CLEARENCE_STATUS_ERROR = 'UPDATE_CLEARENCE_STATUS_ERROR';

export const POST_PROGRESS_REPORT_DOCUMENT_DETAILS = 'POST_PROGRESS_REPORT_DOCUMENT_DETAILS';
export const POST_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR = 'POST_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR';

export const GET_PROGRESS_REPORT_DOCUMENT_DETAILS = 'GET_PROGRESS_REPORT_DOCUMENT_DETAILS';
export const GET_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR = 'GET_PROGRESS_REPORT_DOCUMENT_DETAILS_ERROR';

export const POST_ALL_DOCUMENT_SUBMITTED_STATUS = 'POST_ALL_DOCUMENT_SUBMITTED_STATUS';
export const POST_ALL_DOCUMENT_SUBMITTED_STATUS_ERROR = 'POST_ALL_DOCUMENT_SUBMITTED_STATUS_ERROR';

export const SET_FLAG = 'SET_FLAG';
export const SET_FLAG_ERROR = 'SET_FLAG_ERROR';

export const DELETE_ASSIGNED_ENGINEER = 'DELETE_ASSIGNED_ENGINEER';
export const DELETE_ASSIGNED_ENGINEER_ERROR = 'DELETE_ASSIGNED_ENGINEER_ERROR';

export const GET_ALL_LINE_ITEMS_SP_CASE = 'GET_ALL_LINE_ITEMS_SP_CASE';
export const GET_ALL_LINE_ITEMS_SP_CASE_ERROR = 'GET_ALL_LINE_ITEMS_SP_CASE_ERROR';

export const UPDATE_REMARKS = 'UPDATE_REMARKS';
export const UPDATE_REMARKS_ERROR = 'UPDATE_REMARKS_ERROR';

export const GET_ALL_DOCUMENTS_FROM_QA = 'GET_ALL_DOCUMENTS_FROM_QA';
export const GET_ALL_DOCUMENTS_FROM_QA_ERROR = 'GET_ALL_DOCUMENTS_FROM_QA_ERROR';

export const GET_ALL_FILTERS = 'GET_ALL_FILTERS';
export const GET_ALL_FILTERS_ERROR = 'GET_ALL_FILTERS_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const REMOVE_ROW_FROM_DISPLAY_TABLES = 'REMOVE_ROW_FROM_DISPLAY_TABLES';
export const REMOVE_ROW_FROM_DISPLAY_TABLES_ERROR = 'REMOVE_ROW_FROM_DISPLAY_TABLES_ERROR';

export const GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS = 'GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS';
export const GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS_ERROR = 'GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS_ERROR';

export const GET_PAYMENT_TERM_SEARCH = 'GET_PAYMENT_TERM_SEARCH';
export const GET_PAYMENT_TERM_SEARCH_ERROR = 'GET_PAYMENT_TERM_SEARCH_ERROR';

export const PROJECT_ALLOCATION_DATA = 'PROJECT_ALLOCATION_DATA';
export const PROJECT_ALLOCATION_DATA_ERROR = 'PROJECT_ALLOCATION_DATA_ERROR';

export const GET_PROJECT_ALLOCATION_DETAILS = 'GET_PROJECT_ALLOCATION_DETAILS';
export const GET_PROJECT_ALLOCATION_DETAILS_ERROR = 'GET_PROJECT_ALLOCATION_DETAILS_ERROR';

export const SUBMIT_INVOICE_DOCUMENTS = 'SUBMIT_INVOICE_DOCUMENTS';
export const SUBMIT_INVOICE_DOCUMENTS_ERROR = 'SUBMIT_INVOICE_DOCUMENTS_ERROR';

export const GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL = 'GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL';
export const GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL_ERROR = 'GET_INVOICE_DETAILS_FOR_AP_TEAM_APPROVAL_ERROR';

export const GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM = 'GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM';
export const GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM_ERROR = 'GET_DOCUMNETS_COMMENTS_FOR_AP_TEAM_ERROR';

export const SEND_TEST_MAIL = 'SEND_TEST_MAIL';
export const SEND_TEST_MAIL_ERROR = 'SEND_TEST_MAIL_ERROR';

export const POST_PROGRESS_COMMENTS = 'POST_PROGRESS_COMMENTS';
export const POST_PROGRESS_COMMENTS_ERROR = 'POST_PROGRESS_COMMENTS_ERROR';

export const GET_PROGRESS_COMMENTS = 'GET_PROGRESS_COMMENTS';
export const GET_PROGRESS_COMMENTS_ERROR = 'GET_PROGRESS_COMMENTS_ERROR';

export const INSERT_DISPATCH_TEMPLATE_DATA = 'INSERT_DISPATCH_TEMPLATE_DATA';
export const INSERT_DISPATCH_TEMPLATE_DATA_ERROR = 'INSERT_DISPATCH_TEMPLATE_DATA_ERROR';

export const GET_ALL_CALLS = 'GET_ALL_CALLS';
export const GET_ALL_CALLS_ERROR = 'GET_ALL_CALLS_ERROR';

export const POST_CUSTOMER_IC_DATE = 'POST_CUSTOMER_IC_DATE';
export const POST_CUSTOMER_IC_DATE_ERROR = 'POST_CUSTOMER_IC_DATE_ERROR';

export const GET_NEW_INSPECTIONS_BY_INSPECTORID = 'GET_NEW_INSPECTIONS_BY_INSPECTORID';
export const GET_NEW_INSPECTIONS_BY_INSPECTORID_ERROR = 'GET_NEW_INSPECTIONS_BY_INSPECTORID_ERROR';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_ERROR = 'GET_NOTIFICATIONS_ERROR';

export const SUBMIT_INVOICE_DOCUMENTS_PARTIAL = 'SUBMIT_INVOICE_DOCUMENTS_PARTIAL';
export const SUBMIT_INVOICE_DOCUMENTS_PARTIAL_ERROR = 'SUBMIT_INVOICE_DOCUMENTS_PARTIAL_ERROR';

export const UPDATE_PARTIAL_DOCUMENT_STATUS = 'UPDATE_PARTIAL_DOCUMENT_STATUS';
export const UPDATE_PARTIAL_DOCUMENT_STATUS_ERROR = 'UPDATE_PARTIAL_DOCUMENT_STATUS_ERROR';

export const GET_DISPATCH_TEMPLATE_MASTER_DATA = 'GET_DISPATCH_TEMPLATE_MASTER_DATA';
export const GET_DISPATCH_TEMPLATE_MASTER_DATA_ERROR = 'GET_DISPATCH_TEMPLATE_MASTER_DATA_ERROR';

export const POST_DISPATCH_TEMPLATE_MASTER_DATA = 'POST_DISPATCH_TEMPLATE_MASTER_DATA';
export const POST_DISPATCH_TEMPLATE_MASTER_DATA_ERROR = 'POST_DISPATCH_TEMPLATE_MASTER_DATA_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_ICListing_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH_PO_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2 = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH2_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3 = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH3_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4 = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_FOR_DISPATCH4_ERROR';

export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH';
export const GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH_ERROR = 'GET_PURCHASE_ORDERS_AND_LINEITEM_LIST_COUNT_FOR_DISPATCH_ERROR';

export const POST_DISPATCH_CLERANCE_DETAILS = 'POST_DISPATCH_CLERANCE_DETAILS';
export const POST_DISPATCH_CLERANCE_DETAILS_ERROR = 'POST_DISPATCH_CLERANCE_DETAILS_ERROR';

export const GET_DISPATCH_TEMPLATE_DETAILS = 'GET_DISPATCH_TEMPLATE_DETAILS';
export const GET_DISPATCH_TEMPLATE_DETAILS_ERROR = 'GET_DISPATCH_TEMPLATE_DETAILS_ERROR';

export const POST_BILLINGSCHEDULE_DETAILS = 'POST_BILLINGSCHEDULE_DETAILS';
export const POST_BILLINGSCHEDULE_DETAILS_ERROR = 'POST_BILLINGSCHEDULE_DETAILS_ERROR';

export const GET_BILLINGSCHEDULE_DETAILS = 'GET_BILLINGSCHEDULE_DETAILS';
export const GET_BILLINGSCHEDULE_DETAILS_ERROR = 'GET_BILLINGSCHEDULE_DETAILS_ERROR';

export const POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS = 'POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS';
export const POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR = 'POST_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR';

export const GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS = 'GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS';
export const GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR = 'GET_BILLINGSCHEDULE_DESCRIPTION_DETAILS_ERROR';

export const POST_BILLINGSCHEDULECLAIMED = 'POST_BILLINGSCHEDULECLAIMED';
export const POST_BILLINGSCHEDULECLAIMED_ERROR = 'POST_BILLINGSCHEDULECLAIMED_ERROR';

export const POST_DISPATCH_INVOICE_FOR_DC = 'POST_DISPATCH_INVOICE_FOR_DC';
export const POST_DISPATCH_INVOICE_FOR_DC_ERROR = 'POST_DISPATCH_INVOICE_FOR_DC_ERROR';

export const POST_GRN_DETAILS_AGAINST_INVOICE = 'POST_GRN_DETAILS_AGAINST_INVOICE';
export const POST_GRN_DETAILS_AGAINST_INVOICE_ERROR = 'POST_GRN_DETAILS_AGAINST_INVOICE_ERROR';

export const POST_BG_DETAILS = 'POST_BG_DETAILS';
export const POST_BG_DETAILS_ERROR = 'POST_BG_DETAILS_ERROR';

export const GET_BG_DETAILS = 'GET_BG_DETAILS';
export const GET_BG_DETAILS_ERROR = 'GET_BG_DETAILS_ERROR';

export const BG_UPLOAD = 'BG_UPLOAD';
export const BG_UPLOAD_ERROR = 'BG_UPLOAD_ERROR';

export const BG_DOC_DETAIL_GET = 'BG_DOC_DETAIL_GET';
export const BG_DOC_DETAIL_GET_ERROR = 'BG_DOC_DETAIL_GET_ERROR';

export const BG_Draft_UPLOAD = 'BG_Draft_UPLOAD';
export const BG_Draft_UPLOAD_ERROR = 'BG_Draft_UPLOAD_ERROR';

export const BG_Draft_UPDATE = 'BG_Draft_UPDATE';
export const BG_Draft_UPDATE_ERROR = 'BG_Draft_UPDATE_ERROR';

export const PO_BG_Draft_UPLOAD = 'PO_BG_Draft_UPLOAD';
export const PO_BG_Draft_UPLOAD_ERROR = 'PO_BG_Draft_UPLOAD_ERROR';

export const PO_BG_Draft_UPDATE = 'PO_BG_Draft_UPDATE';
export const PO_BG_Draft_UPDATE_ERROR = 'PO_BG_Draft_UPDATE_ERROR';

export const BG_Draft_GET = 'BG_Draft_GET';
export const BG_Draft_GET_ERROR = 'BG_Draft_GET_ERROR';

export const PO_DETAIL_GET = 'PO_DETAIL_GET';
export const PO_DETAIL_GET_ERROR = 'PO_DETAIL_GET_ERROR';

export const POST_CREATEUSER = 'POST_CREATEUSER';
export const POST_CREATEUSER_ERROR = 'POST_CREATEUSER_ERROR';

export const GET_SIGNUP = 'GET_SIGNUP';
export const GET_SIGNUP_ERROR = 'GET_SIGNUP_ERROR';
export const POST_ADDITIONAL_EMAILID = 'POST_ADDITIONAL_EMAILID';
export const POST_ADDITIONAL_EMAILID_ERROR = 'POST_ADDITIONAL_EMAILID_ERROR';
export const GET_EXCEL_EXPORT_DATA = 'GET_EXCEL_EXPORT_DATA';
export const GET_EXCEL_EXPORT_DATA_ERROR = 'GET_EXCEL_EXPORT_DATA_ERROR';
export const GET_DRAFT_DOCUMENTS = 'GET_DRAFT_DOCUMENTS';
export const GET_DRAFT_DOCUMENTS_ERROR = 'GET_DRAFT_DOCUMENTS_ERROR';

export const GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS = 'GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS';
export const GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS_ERROR = 'GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS_ERROR';

export const REQUEST_PAYMENT_FOR_LOGISTICS = 'REQUEST_PAYMENT_FOR_LOGISTICS';
export const REQUEST_PAYMENT_FOR_LOGISTICS_ERROR = 'REQUEST_PAYMENT_FOR_LOGISTICS_ERROR';

export const POST_REJECTHOLDINSPECTION = 'POST_REJECTHOLDINSPECTION';
export const POST_REJECTHOLDINSPECTION_ERROR = 'POST_REJECTHOLDINSPECTION_ERROR';

export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const UPDATE_NOTIFICATION_ERROR = 'UPDATE_NOTIFICATION_ERROR';

export const POST_VENDOR_DETAILS = 'POST_VENDOR_DETAILS';
export const POST_VENDOR_DETAILS_ERROR = 'POST_VENDOR_DETAILS_ERROR';
export const GET_ALL_GRNS = 'GET_ALL_GRNS';
export const GET_ALL_GRNS_ERROR = 'GET_ALL_GRNS_ERROR';

export const GET_ALL_GRN_EXPORT = 'GET_ALL_GRN_EXPORT';
export const GET_ALL_GRNS__EXPORT_ERROR = 'GET_ALL_GRNS__EXPORT_ERROR';

export const GET_POLINEITEMS_FOR_SAMETEMPLATE = 'GET_POLINEITEMS_FOR_SAMETEMPLATE';
export const GET_POLINEITEMS_FOR_SAMETEMPLATE_ERROR = 'GET_POLINEITEMS_FOR_SAMETEMPLATE_ERROR';

export const GET_SAME_STAGES_BYLINEITEMID = 'GET_SAME_STAGES_BYLINEITEMID';
export const GET_SAME_STAGES_BYLINEITEMID_ERROR = 'GET_SAME_STAGES_BYLINEITEMID_ERROR';

export const UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT = 'UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT';
export const UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT_ERROR = 'UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT_ERROR';

export const Waive_Off_Inspection = 'Waive_Off_Inspection';
export const Waive_Off_Inspection_ERROR = 'Waive_Off_Inspection_ERROR';

export const PENDING_ACTIVITIES = 'PENDING_ACTIVITIES';
export const PENDING_ACTIVITIES_ERROR = 'PENDING_ACTIVITIES_ERROR';

export const GET_PROJECT_ALLOCATION_BY_USERID = 'GET_PROJECT_ALLOCATION_BY_USERID';
export const GET_PROJECT_ALLOCATION_BY_USERID_ERROR = 'GET_PROJECT_ALLOCATION_BY_USERID_ERROR';

export const GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS = 'GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS';
export const GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS_ERROR = 'GET_DEFAULT_DISPATCH_TEMPLATE_DETAILS_ERROR';

export const GET_CUSTOMER_MASTER = 'GET_CUSTOMER_MASTER';
export const GET_CUSTOMER_MASTER_ERROR = 'GET_CUSTOMER_MASTER_ERROR';

export const POST_CUSTOMER_MASTER = 'POST_CUSTOMER_MASTER';
export const POST_CUSTOMER_MASTER_ERROR = 'POST_CUSTOMER_MASTER_ERROR';

export const GET_DOCUMENT_FOR_QA = 'GET_DOCUMENT_FOR_QA';
export const GET_DOCUMENT_FOR_QA_ERROR = 'GET_DOCUMENT_FOR_QA_ERROR';

export const GET_QADOCUMENT_BY_POLINEITEMID = 'GET_QADOCUMENT_BY_POLINEITEMID';
export const GET_QADOCUMENT_BY_POLINEITEMID_ERROR = 'GET_QADOCUMENT_BY_POLINEITEMID_ERROR';

export const GET_QA_ACTIVITY = 'GET_QA_ACTIVITY';
export const GET_QA_ACTIVITY_ERROR = 'GET_QA_ACTIVITY_ERROR';

export const POST_NON_PO = 'POST_NON_PO';
export const POST_NON_PO_ERROR = 'POST_NON_PO_ERROR';

export const BG_STATUS_UPDATE = 'BG_STATUS_UPDATE';
export const BG_STATUS_UPDATE_ERROR = 'BG_STATUS_UPDATE_ERROR';

export const BG_Request_ACTION = 'BG_Request_ACTION';
export const BG_Request_ACTION_ERROR = 'BG_Request_ACTION_ERROR';

export const PO_BG_Draft_ACTION = 'PO_BG_Draft_ACTION';
export const PO_BG_Draft_ACTION_ERROR = 'PO_BG_Draft_ACTION_ERROR';

export const GET_PO_LINEITEM_DETAILS = 'GET_PO_LINEITEM_DETAILS';
export const GET_PO_LINEITEM_DETAILS_ERROR = 'GET_PO_LINEITEM_DETAILS_ERROR';
